import React, { useState } from 'react';

import Modal from 'components/ModalV2';
import PropTypes from 'prop-types';

import styles from './CustomFieldFlowChart.module.css';

import FlowChartCanvas from './components/FlowChartCanvas';

function CustomFieldFlowChart({ workflowConfig }) {
    const [openPreview, setOpenPreview] = useState(false);

    const handlePreview = () => setOpenPreview(!openPreview);

    return (
        <>
            <FlowChartCanvas
                workflowConfig={workflowConfig}
                openPreview={openPreview}
                handleOpenPreview={handlePreview}
            />
            <Modal
                open={openPreview}
                onClose={() => setOpenPreview(false)}
                className={styles.flowChartPreviewModalContainer}
            >
                <FlowChartCanvas
                    workflowConfig={workflowConfig}
                    openPreview={openPreview}
                    handleOpenPreview={handlePreview}
                />
            </Modal>
        </>
    );
}

CustomFieldFlowChart.propTypes = {
    workflowConfig: PropTypes.object,
};

export default CustomFieldFlowChart;
